import React from "react";
// NAVIGATION
import { useNavigate } from "react-router-dom";
// ANT DESIGN COMPONENTS
import { Dropdown, MenuProps, Space } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faClone,
	faCode,
	faEllipsis,
	faGears,
	faPenToSquare,
	faTrash,
} from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import {
	updateAdapter,
	updateOpenModalCreateNewAdapter,
	updateFormCreateEdit,
	updateOpenModalDeleteAdapter,
} from "../../../redux/adapters/adapterSlice";
import { updateOpenDrawerAssignInterfaceAdapter } from "../../../redux/keys/keysSlice";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
// COMPONENTS
import TableActionsMenuItem from "../../components/table/TableActionsMenuItem";
// INTERFACES
import { AdaptersTableActionsInterface } from "../../../interfaces/Adapter.interface";
// INTERFACES
import { RootState } from "../../../app/store";

function AdaptersTableActions({ selectedItem }: AdaptersTableActionsInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();
	const [t] = useTranslation("global");
	const navigate = useNavigate();

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { permissions } = useSelector((state: RootState) => state.user);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	const handleOpenModalDelete = () => {
		dispatch(updateAdapter(selectedItem));
		dispatch(updateOpenModalDeleteAdapter(true));
	};
	const handleOpenModalEdit = () => {
		dispatch(updateAdapter(selectedItem));
		dispatch(updateOpenModalCreateNewAdapter(true));
		dispatch(updateFormCreateEdit("EDIT"));
	};

	const handleOpenModalDuplicate = () => {
		dispatch(updateAdapter(selectedItem));
		dispatch(updateOpenModalCreateNewAdapter(true));
		dispatch(updateFormCreateEdit("DUPLICATE"));
	};

	const handleOpenConfigurationKeys = () => {
		navigate({
			pathname: "/edge-management/adapter/configuration-keys",
			search: `?idAdapter=${selectedItem.id}`,
		});
	};

	const handleOpenConfigurationOffsets = () => {
		navigate({
			pathname: "/edge-management/adapter/configuration-offsets",
			search: `?idAdapter=${selectedItem.id}`,
		});
	};

	const handleOpenConfigurationActions = () => {
		navigate({
			pathname: "/edge-management/adapter/configuration-actions",
			search: `?idAdapter=${selectedItem.id}`,
		});
	};

	const handleOpenConfigurationIconDefinitions = () => {
		navigate({
			pathname: "/edge-management/adapter/configuration-icon-definitions",
			search: `?idAdapter=${selectedItem.id}`,
		});
	};

	const handleOpenAssignInterface = () => {
		dispatch(updateAdapter(selectedItem));
		dispatch(updateOpenDrawerAssignInterfaceAdapter(true));
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// ROW ACTIONS ************************************ */
	const manageActions = () => {
		const EDIT = validatePermission("adapters-update", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faPenToSquare}
							text={t("adapter.edit")}
							onClick={handleOpenModalEdit}
						/>
					),
					key: "1",
			  }
			: null;

		const DUPLICATE = validatePermission("adapters-create", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faClone}
							text={t("general.duplicateAdapter")}
							onClick={handleOpenModalDuplicate}
						/>
					),
					key: "2",
			  }
			: null;

		const INTERFACE = validatePermission("adapters-update", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faCode}
							text={t("general.interfaceAssign")}
							onClick={handleOpenAssignInterface}
						/>
					),
					key: "3",
			  }
			: null;

		const KEYS = validatePermission("adapters-update", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faGears}
							text={t("general.configurationKeys")}
							onClick={handleOpenConfigurationKeys}
						/>
					),
					key: "4",
			  }
			: null;

		const OFFSETS = validatePermission("adapters-update", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faGears}
							text={t("general.configurationOffsets")}
							onClick={handleOpenConfigurationOffsets}
						/>
					),
					key: "5",
			  }
			: null;

		const ACTIONS = validatePermission("adapters-update", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faGears}
							text={t("general.configurationActions")}
							onClick={handleOpenConfigurationActions}
						/>
					),
					key: "6",
			  }
			: null;

		const ICON_DEFINITIONS = validatePermission("adapters-update", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faGears}
							text={t("general.configurationIconDefinitions")}
							onClick={handleOpenConfigurationIconDefinitions}
						/>
					),
					key: "7",
			  }
			: null;

		const DELETE = validatePermission("adapters-delete", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faTrash}
							text={t("adapter.delete")}
							onClick={handleOpenModalDelete}
						/>
					),
					key: "9",
			  }
			: null;

		if (
			selectedItem &&
			selectedItem.lift_type &&
			selectedItem.lift_type === "ELEVATOR"
		) {
			return [
				EDIT,
				DUPLICATE,
				INTERFACE,
				KEYS,
				ACTIONS,
				OFFSETS,
				ICON_DEFINITIONS,
				DELETE,
			];
		}
		return [EDIT, DUPLICATE, INTERFACE, KEYS, ACTIONS, OFFSETS, DELETE];
	};
	const menu: MenuProps = {
		items: manageActions(),
	};
	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<Dropdown menu={menu} trigger={["click"]}>
				<Space className='generalStyles__hoverCursor'>
					<FontAwesomeIcon icon={faEllipsis} />
				</Space>
			</Dropdown>
		</div>
	);
}

export default AdaptersTableActions;
